
        import {css} from 'lit';
        export default css`.animated-number-current{display:none}`;
    